import { useEffect, useState } from 'react';
import { Box } from '@primerai/thread';
import ForgotPasswordLink from './ForgotPasswordLink';
import Form from './Form';
import { useLoginState, useResetPasswordOnLogin } from './helpers';
import { Next as NextType } from './types';
import { getWindow } from '~/utils/window';

const PAGES = {
  DEFAULT: 'DEFAULT',
  DONE: 'DONE',
};

type PagesType = keyof typeof PAGES;

type ContentType = {
  displayPage: PagesType;
  isSSOPrompt: boolean;
  next: NextType;
};

const Content = ({ displayPage, isSSOPrompt, next: Next }: ContentType) => {
  const isDisplayPageDone = displayPage === PAGES.DONE;
  const nextView = isDisplayPageDone ? <Next /> : null;
  const formView = !isDisplayPageDone ? (
    <Form isSSOPrompt={isSSOPrompt} />
  ) : null;

  return (
    <Box>
      {nextView}
      {formView}
      <ForgotPasswordLink />
    </Box>
  );
};

const LoginForm = ({ next }: { next: NextType }) => {
  useResetPasswordOnLogin();
  const { success, url: urlSAMLProvider, error } = useLoginState();
  const [isSSOPrompt, setIsSSOPrompt] = useState(true);
  const [displayPage, setDisplayPage] = useState<PagesType>(
    PAGES.DEFAULT as PagesType,
  );

  useEffect(() => {
    const isSAMLRedirectRequired = success && urlSAMLProvider;
    const isUserAuthenticated = success && !urlSAMLProvider;
    const isPasswordRequired = success === false;

    if (isSAMLRedirectRequired) {
      getWindow().location = urlSAMLProvider;
    }

    if (isUserAuthenticated) {
      setDisplayPage(PAGES.DONE as PagesType);
    }

    if (isPasswordRequired && !error) {
      setIsSSOPrompt(false);
    }
  }, [success, urlSAMLProvider]);

  return (
    <Content displayPage={displayPage} isSSOPrompt={isSSOPrompt} next={next} />
  );
};

export default LoginForm;
